<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Instrument Score Information</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Customer Name </label>
          <input [(ngModel)]="CustomerName" type="text" class="form-control"
            placeholder="Type to search...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Status</label>
          <select class="custom-select" [(ngModel)]="SubmitAccept" name="SubmitAccept">
            <option value="0">All</option>
            <option value="1">Approved</option>
            <option value="-1">Not Approved</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Work Location</label>
          <select class="custom-select" [(ngModel)]="LocationOfCalibration" name="LocationOfCalibration">
            <option value="0">All</option>
            <option value="1">Laboratory</option>
            <option value="2">Site</option>
          </select>
        </div>

      </div>

      <div class="row">


        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Calibration Technician </label>
          <app-ExpertCalibrationOption [inner_Expert_Lab]="true"
            (OnBack_ExpertCalibration_Action)="OnGet_ExpertCalibration_Action($event)">

          </app-ExpertCalibrationOption>
        </div>

        
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Instrument Name </label>
          <input [(ngModel)]="DeviceName" type="text" class="form-control"
            placeholder="Type to search...">
        </div>
        
      </div>

      <div class="row">
        <div class="form-group col-md-12">

          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Point(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;">
            <i class="fa   fa-file-excel-o"></i>Excel
          </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Calibration Technician Name </th>
              <th>Customer</th>
              <th>Instrument Name </th>
              <th>Work Assignment Time (Start) </th>
              <th>Certificate Registration Time</th>
              <th>Certificate Number</th>
              <th>Description Reviewer</th>
              <th>Review Date</th>
              <th>Reviewer</th>
              <th>Work Completion Time (End) </th>
              <th>Days</th>
              <th>Daily Score</th>
              <th>Score</th>
              <th>Revision</th>

              <th>Tariff</th>
              <th>Expense</th>
              <th>Revenue</th>
              
              <th>T4</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Kartable| paginate
            : {
                id: 'DataList_KartableTable',
                itemsPerPage: 20,
                currentPage: page,
                totalItems: (DataList_Kartable
                ).length
              }">
              <td>{{DataList_Kartable.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.title}}</td>
              <td>{{item.tarikh_tahvil}}</td>
              <td>{{item.tarikh_sbat}}</td>
              <td>{{item.certificate_user_code}}</td>
              <td>{{item.controller_dsc}}</td>
              <td>{{item.controller_date}}</td>
              <td>{{item.controller_user}}</td>
              <td>{{item.tarikh_khoroj}}</td>
              <td>{{item.day}}</td>
              <td>{{item.daypoint}}</td>
              <td>{{item.point}}</td>
              <td (click)="openModal(template,item.controller)">
                <span style="text-decoration: underline;cursor: pointer;">{{item.controller.length}}</span>
              </td>

              <td  (click)="openModal1(template1,item.tariff)">
                <span style="text-decoration: underline;cursor: pointer;">{{item.tariff[0]}}</span>
              </td>

              <td>{{item.tariff[7]}}</td>
              <td>{{item.tariff[8]}}</td>

              <td>{{item.t4}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_KartableTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Revision Notes </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Baznegari.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <ul>
            <li *ngFor="let item of Datalist_Baznegari">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Baznegari.hide()">Close</button>
  </div>
</ng-template>

<ng-template #template1>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Tariff Details </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Baznegari1.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Tariff</label>
          <input disabled value="{{Datalist_Baznegari1[1]}}" type="text" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Manager Adjustment</label>
          <input disabled value="{{Datalist_Baznegari1[2]}}" type="text" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Discount</label>
          <input disabled value="{{Datalist_Baznegari1[4]}} ({{Datalist_Baznegari1[3]}} % )" type="text" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Value Added Tax</label>
          <input disabled value="{{Datalist_Baznegari1[6]}} ({{Datalist_Baznegari1[5]}} % )" type="text" class="form-control">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Baznegari1.hide()">Close</button>
  </div>
</ng-template>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Calibration Technician Name </th>
      <th>Customer</th>
      <th>Instrument Name </th>
      <th>Work Assignment Time (Start) </th>
      <th>Certificate Registration Time</th>
      <th>Certificate Number</th>
      <th>Description Reviewer</th>
      <th>Review Date</th>
      <th>Reviewer</th>
      <th>Work Completion Time (End) </th>
      <th>Days</th>
      <th>Daily Score</th>
      <th>Score</th>
      <th>Revision</th>

      <th>Tariff</th>
      <th>Expense</th>
      <th>Revenue</th>
      <th>T4</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Kartable">
      <td>{{DataList_Kartable.indexOf(item)+1}}</td>
      <td>{{item.fullname}}</td>
      <td>{{item.customer}}</td>
      <td>{{item.title}}</td>
      <td>{{item.tarikh_tahvil}}</td>
      <td>{{item.tarikh_sbat}}</td>
      <td>{{item.certificate_user_code}}</td>
      <td>{{item.controller_dsc}}</td>
      <td>{{item.controller_date}}</td>
      <td>{{item.controller_user}}</td>
      <td>{{item.tarikh_khoroj}}</td>
      <td>{{item.day}}</td>
      <td>{{item.daypoint}}</td>
      <td>{{item.point}}</td>
      <td >{{item.controller.length}}</td>

      <td>{{item.tariff[0]}}</td>
      <td>{{item.tariff[7]}}</td>
      <td>{{item.tariff[8]}}</td>

      <td>{{item.t4}}</td>
    </tr>
  </tbody>
</table>